
import { PayoutConfig } from "../model/payoutConfig";
import { ChangeRequestStatus, TurnoutReason } from "../model/registration-change-request";
import { RodeoEvent } from "../model/rodeoEvent";
import { RodeoEventRun } from "../model/rodeoEventRun";

export class RunDisplayHelper {
    private static _instance: RunDisplayHelper;

    private constructor() { }

    static instance(): RunDisplayHelper {
        if (this._instance == undefined)
            this._instance = new this();

        return this._instance;
    }

    getFirstLabel(rodeoEvent: RodeoEvent) {
        return rodeoEvent.configuration.runs.slotOneLabel;
    }

    getFirstDisplay(rodeoEvent: RodeoEvent, run: RodeoEventRun) {
        var firstDisplayValue = '';

        var valuesToDisplay = rodeoEvent.configuration.runs.slotOneFieldName.split('+');

        valuesToDisplay.forEach(value => {
            var propertiesInValue = value.split('.');

            var objectWithValue: any;
            objectWithValue = run;

            var lastProperty = '';
            propertiesInValue.forEach(property => {
                if (!objectWithValue) {
                    objectWithValue = lastProperty == 'livestock' ? 'Livestock 1' : 'Horse 1';
                    return;
                }

                objectWithValue = objectWithValue[property];
                lastProperty = property;
            });

            firstDisplayValue += objectWithValue + ' ';
        });

        return firstDisplayValue.substring(0, firstDisplayValue.length - 1) + ((rodeoEvent.configuration.runs.slotOneFieldName.includes('contestantOne') && run.isExtraRunForContestantOne) ? '*' : '');
    }

    getSecondDisplay(rodeoEvent: RodeoEvent, run: RodeoEventRun) {
        var secondDisplayValue = '';

        var valuesToDisplay = rodeoEvent.configuration.runs.slotTwoFieldName.split('+');

        valuesToDisplay.forEach(value => {
            var propertiesInValue = value.split('.');

            var objectWithValue: any;
            objectWithValue = run;

            var lastProperty = '';
            propertiesInValue.forEach(property => {
                if (!objectWithValue) {
                    objectWithValue = lastProperty == 'livestock' ? 'Livestock 1' : 'Horse 1';
                    return;
                }

                objectWithValue = objectWithValue[property];
                lastProperty = property;
            });

            secondDisplayValue += objectWithValue + ' ';
        });

        return secondDisplayValue.substring(0, secondDisplayValue.length - 1) + ((rodeoEvent.configuration.runs.slotTwoFieldName.includes('contestantTwo') && run.isExtraRunForContestantTwo) ? '*' : '');
    }

    getSecondLabel(rodeoEvent: RodeoEvent, run: RodeoEventRun) {
        return rodeoEvent.configuration.runs.slotTwoLabel == 'Stock' && run && run.livestock ? run.livestock.brand + run.livestock.name : rodeoEvent.configuration.runs.slotTwoLabel;
    }

    getRunValue(rodeoEvent: RodeoEvent, run: RodeoEventRun, total: boolean = false, leaders: boolean = false, leaderMode: PayoutConfig = null) {
        if (!total || run.displaySuccessfulRuns == 0) {
            if (run.disqualified)
                return 'DQ';

            if (run.inReview)
                return 'REVIEW';

            if (run.noTime)
                return rodeoEvent.configuration.runs.scoreValue ? "NS" : "NT";

            if (run.turnedOut)
            {
                const registrations = rodeoEvent.registrations.filter(x => x.runIdentifier == run.runIdentifier);

                if (registrations.length > 0 && registrations[0].changeRequests.length > 0 && (registrations[0].changeRequests[0].status == ChangeRequestStatus.ApprovedPendingPayment || registrations[0].changeRequests[0].status == ChangeRequestStatus.Completed))
                {
                    const changeRequest = registrations[0].changeRequests[0];

                    if (changeRequest.turnoutReason == TurnoutReason.DoctorRelease)
                        return "DR";
                    else if (changeRequest.turnoutReason == TurnoutReason.VetRelease)
                        return "VR";
                    else if (changeRequest.turnoutReason == TurnoutReason.Drawout)
                        return "DO";
                    else if (changeRequest.turnoutReason == TurnoutReason.NonNotifiedTurnout)
                        return "NNTO";
                    else if (changeRequest.turnoutReason == TurnoutReason.NotifiedTurnout)
                        return "NTO";
                    else if (changeRequest.turnoutReason == TurnoutReason.VisibleInjury)
                        return "VI";
                }

                return "TO";
            }
        }

        let extraOnDisplay = !leaderMode ? '' : (leaderMode.isAverage || leaderMode.isAggregate) && run.displaySuccessfulRuns > 0 && total ? ' on ' + run.displaySuccessfulRuns : '';
        var displayString = run.time;

        if (rodeoEvent.configuration.runs.scoreValue) {
            displayString = run.score;

            if (run.done) {
                displayString = !total ? run.score : run.totalScore;
            }
        } else {
            if (run.done) {
                if (leaders && leaderMode.name.includes('Barrel One Split')) {
                    displayString = +run.straightOneSplit + +run.aroundBarrelOneSplit;
                } else if (leaders && leaderMode.name.includes('Home Split')) {
                    displayString = +run.straightFourSplit;
                } else {
                    displayString = !total ? run.time : run.totalTime;
                }
            }
        }

        if (displayString == 0 || !displayString)
            return '';

        var formattedDisplayString = displayString;

        try
        {
            formattedDisplayString = (+displayString).toFixed(rodeoEvent.configuration.runs.decimalPlaces) + extraOnDisplay;
        }
        catch (exception)
        {
            console.log("displayString: " + displayString);
            console.log("ERROR: " + exception);
        }

        return formattedDisplayString;
    }
}


// WEBPACK FOOTER //
// ./src/lib/run-display-helper.ts